// Échap des 3 fiches (dépannage, atelier, location — décision Jordan
// 31.10.2026) : retour à la recherche MÊME depuis un champ, sauf :
// - liste à suggestions ouverte : la liste consomme Échap (preventDefault
//   sur un role="combobox" — FilteredSelectV2, ClientAutocomplete) ;
// - fenêtre ouverte dans la page (CustomModal, react-responsive-modal v4 —
//   aria-modal, ses classes sont des CSS-modules —, tiroir d'assistance,
//   visionneuse photo), en plus du state « modal ouvert » de chaque fiche.
// Les masques de saisie qui font aussi preventDefault (typeNumber…) ne sont
// pas des combobox : ils ne bloquent pas Échap.

export const echapConsommeParListe = (e) =>
	!!(
		e.defaultPrevented &&
		e.target &&
		e.target.getAttribute &&
		e.target.getAttribute("role") === "combobox"
	)

// Fenêtre qui se ferme elle-même sur Échap (écouteur window) : marque
// l'événement, car si son écouteur passe AVANT celui de la fiche, elle est
// déjà démontée (et son marqueur DOM retiré) quand la fiche le lit.
export const consommerEchap = (e) => {
	e.echapConsomme = true
}

export const fenetreOuverte = () =>
	!!document.querySelector(
		'[data-custom-modal], [aria-modal="true"], [data-assistance-ui], [data-visionneuse]',
	)

export const echapIgnoreParFiche = (e) =>
	!!e.echapConsomme || echapConsommeParListe(e) || fenetreOuverte()
